import { NumNullArr } from '@iotv/iotv-v3-types'
import { Milliseconds } from '../../constants'
import { roundDecimals } from '../TypeHelpers'

export type DXDY_Request = {
  timeseries: { timestamp: number[]; [k: string]: NumNullArr }
  k: string
  tsmsDivisor: Milliseconds
  decimalRoundTo: number
}

export type DXDY_Response = { timestamp: number[]; [k: string]: number[] } | undefined

export const dxdy = ({ timeseries, k, tsmsDivisor, decimalRoundTo }: DXDY_Request): DXDY_Response => {
  let res: { timestamp: number[]; [k: string]: number[] } | undefined = undefined
  const initial: { timestamp: number[]; [k: string]: number[] } = { timestamp: [], [k]: [] }

  if (timeseries[k]) {
    res = timeseries.timestamp.reduce((acc, thisTimestamp, i) => {
      if (i !== 0) {
        let lastNonNull: number | undefined = undefined
        let prevIdx = i
        const thisVal = timeseries[k][i]

        if (thisVal && !isNaN(thisVal)) {
          // skip zeros, nulls
          do {
            prevIdx--
            const prevTimestamp = timeseries.timestamp[prevIdx]
            const prevVal = timeseries[k][prevIdx]

            if (prevVal && !isNaN(prevVal)) {
              const ceil = Math.ceil((thisTimestamp - prevTimestamp) / tsmsDivisor)
              const dxdy = ceil !== 0 ? roundDecimals((thisVal - prevVal) / ceil, decimalRoundTo) : 0
              acc.timestamp.push(Math.round((prevTimestamp + thisTimestamp) / 2))
              acc[k].push(dxdy)
              lastNonNull = prevVal
            }
          } while (prevIdx >= 0 && lastNonNull === undefined)
        }
      }

      return acc
    }, initial)
  }

  return res
}
